import { Link, useNavigate } from "react-router-dom";
import { getPaywallType, getFunnelType } from "src/appConfig";
import styles from "./styles.module.scss";
import { DATA } from "./data";
import { useEffect, useState } from "react";
import { UserService } from "@api/services/userService";
import authService from "@api/services/authService";
import { KeyboardArrow } from "@assets/Icons";
import { usePreloadImages } from "@hooks/usePreloadImages";
import { errorToast } from "@utils/toaster";
import { Loader } from "@common/loader";
import { useOnboardingTexts } from "src/routes/onboarding/shared/hooks/useOnboardingTexts";
import { updateDataLayer } from "@utils/updateDataLayer";

export const Initiate = ({ onNextStep, onTrackEvent }) => {
  const { getSectionText } = useOnboardingTexts();

  const description = getSectionText("start_age_full").description;

  useEffect(() => {
    updateDataLayer({
      event: "FirstQuestionShown",
    });
  }, []);

  const handleNextStep = (value) => {
    localStorage.setItem("ageStart", value);
    onNextStep?.(value);
    onTrackEvent?.(value);
  };

  return (
    <div className={styles.container} id="breakdown">
      <h1>Personal walking plan tailored to your age</h1>

      <div className={styles.cards}>
        {DATA.map((item) => (
          <div
            key={item.value}
            onClick={() => handleNextStep(item.value)}
            className={styles.card}
          >
            <img src={item.image} alt={item.value} />
            <div className={styles.label}>{item.value}</div>
          </div>
        ))}
      </div>
      <p className={styles.privacy}>
        By choosing your age and continuing you agree to&nbsp;our{" "}
        <Link to="/terms-of-use">Terms of Service</Link> |
        <Link to="/privacy-policy"> Privacy Policy</Link>.<br />
        Please review before continuing.
      </p>
    </div>
  );
};
